import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_DEPLOYMENT_TIER as string | undefined) ?? "dev",
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
} else {
  console.warn("[sentry] VITE_SENTRY_DSN not set — Sentry disabled");
}

// Tag Sentry with the Clerk user ID only — no email/PII.
// Avenue is an internal tool, but Sentry replays and error reports may be
// retained beyond the user's session; keeping PII out of them is the default.
export function tagClerkUser(user: { id: string }) {
  Sentry.setUser({ id: user.id });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
